// export const BaseIp = 'http://192.168.29.113:1111/'     //---local path (URL)
export const BaseIp = 'https://ganpati.metrogroupsmg.com/'     //---online path (URL)

export const IMG_BASE_URL = BaseIp + 'uploads/products/'     //---img path (URL)

// ==================================================================================================
// ==================================================================================================


export const AdminLoginAPI = BaseIp + "api/admin/adminLogin";  //ADMIN LOGIN API (POST)
export const YearListAPI = BaseIp + "api/admin/getAllYear";  //Year List (POST)

// ========= DASHBOARD==========
export const GetDashboardDataAPI = BaseIp + "api/dashboard/dashboard_details";  //Dashboard Data (GET)

// ============= City Master ===============
export const GetCityDataAPI = BaseIp + "api/cities/getAllCity";  //CITY DATA (GET)
export const CreateCityDataAPI = BaseIp + "api/cities/createCity";  //CITY DATA (POST)
export const UpdateCityDataAPI = BaseIp + "api/cities/updateCity";  //CITY DATA (PUT) (params=> (id))
export const DeleteCityDataAPI = BaseIp + "api/admin/adminLogin";  //CITY DATA (DELETE)

// ============= Customer Master ===============
export const GetCustomerDataAPI = BaseIp + "api/customermaster/getAllCustomer";  //Customer DATA (GET)
export const CreateCustomerDataAPI = BaseIp + "api/customermaster/createCustomer";  //Customer DATA (POST)
export const UpdateCustomerDataAPI = BaseIp + "api/customermaster/updateCustomer";  //Customer DATA (PUT) (params=> (id))
export const DeleteCustomerDataAPI = BaseIp + "api/customermaster/adminLogin";  //Customer DATA (DELETE)

// ============= Supplier Master ===============
export const GetSupplierDataAPI = BaseIp + "api/suppliermaster/getAllSuppliers";  //Supplier DATA (GET)
export const CreateSupplierDataAPI = BaseIp + "api/suppliermaster/createSupplier";  //Supplier DATA (POST)
export const UpdateSupplierDataAPI = BaseIp + "api/suppliermaster/updateSupplier";  //Supplier DATA (PUT) (params=> (id))
export const DeleteSupplierDataAPI = BaseIp + "api/suppliermaster/adminLogin";  //Supplier DATA (DELETE)

// ============= Product Master ===============
export const GetProductDataAPI = BaseIp + "api/productmaster/getAllProduct";  //Product DATA (GET)
export const CreateProductDataAPI = BaseIp + "api/productmaster/createProduct";  //Product DATA (POST)
export const UpdateProductDataAPI = BaseIp + "api/productmaster/updateProduct";  //Product DATA (PUT) (params=> (id))
export const DeleteProductDataAPI = BaseIp + "api/productmaster/adminLogin";  //Product DATA (DELETE)

// ============= Raw Material Master ===============
export const GetRawMaterialDataAPI = BaseIp + "api/rawmaterial/getAllRawMaterial";  //RawMaterial DATA (GET)
export const CreateRawMaterialDataAPI = BaseIp + "api/rawmaterial/createRawMaterial";  //RawMaterial DATA (POST)
export const UpdateRawMaterialDataAPI = BaseIp + "api/rawmaterial/updateRawMaterial";  //RawMaterial DATA (PUT) (params=> (id))
export const DeleteRawMaterialDataAPI = BaseIp + "api/rawmaterial/adminLogin";  //RawMaterial DATA (DELETE)


// ====================PRODUCTION API'S============================================================

// ============= Raw Idol Production ===============
export const GetRawIdolDataAPI = BaseIp + "api/rawidolproduction/getAllRawIdolProduction";  //Raw Idol DATA (GET)
export const CreateRawIdolDataAPI = BaseIp + "api/rawidolproduction/createRawIdolProduction";  //Raw Idol DATA (POST)
export const UpdateRawIdolDataAPI = BaseIp + "api/rawidolproduction/updateRawIdolProduction";  //Raw Idol DATA (PUT) (params=> (id))
export const DeleteRawIdolDataAPI = BaseIp + "api/rawidolproduction/deleteRawIdolProduction";  //Raw Idol DATA (DELETE)

// ============= Coloring ===============
export const GetColoringDataAPI = BaseIp + "api/coloring/getColoring";  //Coloring DATA (GET)
export const CreateColoringDataAPI = BaseIp + "api/coloring/createColoring";  //Coloring DATA (POST)
export const UpdateColoringDataAPI = BaseIp + "api/coloring/updateColoring";  //Coloring DATA (PUT) (params=> (id))
export const DeleteColoringDataAPI = BaseIp + "api/coloring/deleteColoring";  //Coloring DATA (DELETE)

export const TotalRawItemProduct = BaseIp + "api/coloring/totalRawItemProduct";  //Total Raw Idol Product (GET) (Coloring - Dropdown)
export const PendingRawItemProductCount = BaseIp + "api/coloring/getPendingColoringItem";  //Pending Raw Item Product Count (GET)  (params=> (id))

// ============= Product Rate ===============
export const GetProductRateDataAPI = BaseIp + "api/productrates/getAllProductRates";  //Product Rate DATA (GET)
export const CreateProductRateDataAPI = BaseIp + "api/productrates/createProductRates";  //Product Rate DATA (POST)
export const UpdateProductRateDataAPI = BaseIp + "api/productrates/updateProductRates";  //Product Rate DATA (PUT) (params=> (id))
export const DeleteProductRateDataAPI = BaseIp + "api/productrates/deleteProductRates";  //Product Rate DATA (DELETE)

// ==================SALES API'S======================================================================

// ============= Orders ===============
export const GetOrdersDataAPI = BaseIp + "api/orders/getAllOrder";  //Orders DATA (GET)
export const CreateOrdersDataAPI = BaseIp + "api/orders/createOrder";  //Orders DATA (POST)
export const UpdateOrdersDataAPI = BaseIp + "api/orders/updateOrder";  //Orders DATA (PUT) (params=> (id))
export const DeleteOrdersDataAPI = BaseIp + "api/orders/deleteOrder";  //Orders DATA (DELETE) (params=> (id))

// ============= Approval Orders ===============
export const GetApprovalOrdersDataAPI = BaseIp + "api/";  //Approval Orders DATA (GET)
export const CreateApprovalOrdersDataAPI = BaseIp + "api/";  //Approval Orders DATA (POST)
export const UpdateApprovalOrdersDataAPI = BaseIp + "api/orders/orderApproval";  //Approval Orders DATA (PUT) (params=> (id))
export const DeleteApprovalOrdersDataAPI = BaseIp + "api/";  //Approval Orders DATA (DELETE)

// ============= Stocks ===============
export const GetStocksDataAPI = BaseIp + "api/stock/getTotalStockDetails";  //Stocks DATA (GET)
export const CreateStocksDataAPI = BaseIp + "api/stock/createStock";  //Stocks DATA (POST)
export const UpdateStocksDataAPI = BaseIp + "api/stock/updateStock";  //Stocks DATA (PUT) (params=> (id))
export const DeleteStocksDataAPI = BaseIp + "api/stock/deleteStock";  //Stocks DATA (DELETE) (params=> (id))

// ============= Breakage Entry ===============
export const GetBreakageEntryDataAPI = BaseIp + "api/breakage_entry/getAllBreakageEntry";  //Breakage Entry DATA (GET)
export const CreateBreakageEntryDataAPI = BaseIp + "api/breakage_entry/createBreakageEntry";  //Breakage Entry DATA (POST)
export const UpdateBreakageEntryDataAPI = BaseIp + "api/breakage_entry/updateBreakageEntry";  //Breakage Entry DATA (PUT) (params=> (id))
export const DeleteBreakageEntryDataAPI = BaseIp + "api/breakage_entry/deleteBreakageEntry";  //Breakage Entry DATA (DELETE) (params=> (id))

// ============= Delivery ===============
export const GetProductDataByBarcodeAPI = BaseIp + "api/delivery/getApprovalCustomerProductPrice";  //(POST) (for getting rate of product)
export const GetDeliveryDataAPI = BaseIp + "api/delivery/getAllDelivery";  //(GET) (Get delivery data)
export const CreateDeliveryDataAPI = BaseIp + "api/delivery/createDelivery";  //(POST) (Create delivery entry)
export const UpdateDeliveryDataAPI = BaseIp + "api/delivery/updateDelivery";  //(PUT) (Update delivery entry)

// ============= Sales Entry ===============
export const GetDeliveryDataOfCustomer = BaseIp + "api/sales/getDeliveryByCustomer";  //Delivery Data Of Selected Customer (GET)
export const GetMultipleDeliveryDetailsOfCustomer = BaseIp + "api/sales/getMultipleDeliveryDetailsByCustomer";  //Delivery Details Data Of Selected Delivery Data (GET)

export const GetSalesDataAPI = BaseIp + "api/sales/getAllSalesEntryData";  //Sales Entry DATA (GET)
export const CreateSalesDataAPI = BaseIp + "api/sales/createSalesEntry";  //Sales Entry DATA (POST)
export const UpdateSalesDataAPI = BaseIp + "api/sales/updateSalesEntry";  //Sales Entry DATA (PUT) (params=> (id))

export const ViewSalesInvoicePdf = BaseIp + "api/sales/viewInvoicePdf";  //Sales Entry Invoice Pdf View (GET) (params=> sales_id/cust_id)

// ============= Payment Receipt ===============
export const GetSaleEntryDataOfCustomer = BaseIp + "api/payment_receipt/getSalesDataByCustomer";  //Get Sales Entry Data of Customer(Dropdown) (params=> cust_id)
export const GetPaymentReceiptDataAPI = BaseIp + "api/payment_receipt/getAllReceipt";  //Payment Receipt DATA (GET)
export const CreatePaymentReceiptDataAPI = BaseIp + "api/payment_receipt/createPaymentReceipt";  //Payment Receipt DATA (POST)
export const ViewPaymentReceiptPdf = BaseIp + "api/payment_receipt/viewPaymentReceiptPdf";  //Payment Receipt Pdf View (GET) (params=>receipt_id, cust_id)


//######### INVENTORY ###########

// ============= Raw Material Purchase ===============
export const GetRawMaterialPurchaseAPI = BaseIp + "api/RawMaterialPurchase/getAllRawMaterialPurchase";  //Raw Material Purchase DATA (GET)
export const CreateRawMaterialPurchaseAPI = BaseIp + "api/RawMaterialPurchase/createRawMaterialPurchase";  //Raw Material Purchase DATA (POST)
export const UpdateRawMaterialPurchaseAPI = BaseIp + "api/RawMaterialPurchase/updateRawMaterialPurchase";  //Raw Material Purchase DATA (PUT) (params=> purchase_id)
export const DeleteRawMaterialPurchaseAPI = BaseIp + "api/RawMaterialPurchase/deleteRawMaterialPurchase";  //Raw Material Purchase DATA (DELETE) (params=> purchase_id)

//############ GENERATE BARCODE ############
export const GenerateBarcodeAPI = BaseIp + "api/barcode/generateBarcode"; // Generate Barcode (POST)

// ########### REPORTS ############

//=============== Production Report ==================
//--------For All Product----------
export const RawProductionReportYearwise = BaseIp + "api/reports/rawProductionReportYearwise";  //Production Report (Raw Idol) Data (GET) (params=> year)
export const ColoringProductReportYearwise = BaseIp + "api/reports/coloringProductReportYearwise";  //Production Report (Coloring) Data (GET) (params=> year)
//-------For Selected Product-------
export const RawIdolProductionReport = BaseIp + "api/reports/productionReport";  //Production Report (Raw Idol) Data (GET) (params=> prod_id,year)
export const ColoringProductionReport = BaseIp + "api/reports/productionColoringReport";  //Production Report (Coloring) Data (GET) (params=> prod_id,year)

//=============== Stock Report ==================
export const StockReportAPI = BaseIp + "api/reports/stockReport";  //Stock Report Data (GET) (params=> prod_id)

//=============== Order Report ==================
export const OrderReportAPI = BaseIp + "api/reports/getAllOrderReport";  //Order Report Data (GET) 

export const OrderReportDateWiseAPI = BaseIp + "api/reports/getAllOrderReportDateWise";  //Order Report Data Date wise (POST) 

//=============== Approval Report ==================
export const ApprovalReportAPI = BaseIp + "api/reports/getAllApprovalOrder";  //Approval Report Data (GET)
export const ApprovalReportDateWiseAPI = BaseIp + "api/reports/getAllApprovalOrderDateWise";  //Approval Report Data Date Wise (POST)

//=============== Delivery Report ==================
export const DeliveryReportAPI = BaseIp + "api/reports/getAllDeliveryReport"; //Delivery Report Data (GET)
export const DeliveryReportDateWiseAPI = BaseIp + "api/reports/getAllDeliveryReportDateWise"; //Delivery Report Data Date Wise (POST)

//=============== Sales Report ==================
export const SalesReportAPI = BaseIp + "api/reports/getAllSalesReport"; //Sales Report Data (GET)
export const SalesReportDateWiseAPI = BaseIp + "api/reports/getAllSalesReportDateWise"; //Sales Report Data Date Wise (POST)

//=============== Payment Collection Report ==================
export const PaymentCollectionReportAPI = BaseIp + "api/reports/paymentCollectionReport"; //Payment Collection Report Data (GET)
export const PaymentCollectionReportDateWiseAPI = BaseIp + "api/reports/paymentCollectionReportDateWise"; //Payment Collection Report Data Date Wise(POST)

//=============== Pending Payment Report ==================
export const PendingPaymentReportAPI = BaseIp + "api/reports/pendingPaymentReport"; //Pending Payment Report Data (GET)
export const PendingPaymentReportDateWiseAPI = BaseIp + "api/reports/pendingPaymentReportDateWise"; //Pending Payment Report Data Date Wise (POST)